/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";

import CheckInCheckoutModalPresenter from "./CheckInCheckoutModalPresenter";
import DTOCheckInCheckoutModal from "./DTOCheckInCheckoutModal";

interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  trans?: any;
  data?: any;
}
const CheckInCheckoutModalController = ({
  isModalOpen,
  closeModal,
  trans,
  data,
}: ModalInterface) => {
  return (
    <>
      <DTOCheckInCheckoutModal />
      <CheckInCheckoutModalPresenter
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        trans={trans}
        attendanceData={data}
      />
    </>
  );
};
export default CheckInCheckoutModalController;
